import { HTTP_ULC_LoadSignUpBranding_Response } from '@api-new/userservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared/models/app-state.model';

export const getSignUpBranding = createAction('[SIGN UP] Get Branding');
export const getSignUpBrandingSuccess = createAction('[SIGN UP] Get Branding Success', props<HTTP_ULC_LoadSignUpBranding_Response>());
export const getSignUpBrandingFailure = createAction('[SIGN UP] Get Branding Failure', props<{ error: ErrorModel }>());

export const setSignUpBrandingReferralCode = createAction('[SIGN UP] Set Branding Referral Code', props<{ referralCode: string }>());
